import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Products } from "@/components/Products";
import { About } from "@/components/About";
import { Careers } from "@/components/Careers";
import { Contact, Footer } from "@/components/Contact";
import Admin from "@/pages/Admin";

const LandingPage = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Products />
      <About />
      <Careers />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
